"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mobileIdentity(criteria, services) {
    var _a;
    var value = criteria ? (_a = criteria[0]) === null || _a === void 0 ? void 0 : _a.values[0] : undefined;
    var storage = services.localStorage;
    var visitorIsIdentified = Boolean(storage.get('mi'));
    switch (value) {
        case 'identified':
            return visitorIsIdentified;
        case 'unidentified':
            return !visitorIsIdentified;
        default:
            return false;
    }
}
exports.default = mobileIdentity;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9iaWxlSWRlbnRpdHkuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi9zZXJ2aWNlcy90YXJnZXRzL21vYmlsZUlkZW50aXR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBR0EsU0FBd0IsY0FBYyxDQUFDLFFBQWtDLEVBQUUsUUFBc0I7O0lBQzdGLElBQU0sS0FBSyxHQUFHLFFBQVEsQ0FBQyxDQUFDLENBQUMsTUFBQSxRQUFRLENBQUMsQ0FBQyxDQUFDLDBDQUFFLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFBO0lBQzNELElBQU0sT0FBTyxHQUFHLFFBQVEsQ0FBQyxZQUFZLENBQUE7SUFDckMsSUFBTSxtQkFBbUIsR0FBRyxPQUFPLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFBO0lBRXRELFFBQVEsS0FBSyxFQUFFO1FBQ1gsS0FBSyxZQUFZO1lBQ2IsT0FBTyxtQkFBbUIsQ0FBQTtRQUM5QixLQUFLLGNBQWM7WUFDZixPQUFPLENBQUMsbUJBQW1CLENBQUE7UUFDL0I7WUFDSSxPQUFPLEtBQUssQ0FBQTtLQUNuQjtBQUNMLENBQUM7QUFiRCxpQ0FhQyJ9